import React from 'react';
import PropTypes from 'prop-types';

const ChatImage = ({ file, onClick }) => (
  <button className="chat-list_image-wrapper" onClick={onClick}>
    <img src={file.url} />
  </button>
);

ChatImage.propTypes = {
  file: PropTypes.shape({}).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default React.memo(ChatImage);



// WEBPACK FOOTER //
// ./app/javascript/common/components/ChatMessage/ChatImage.js